<template>
  <div class="row" v-if="!!workOrder">
    <div class="col-sm-3">
      <h1>{{ workOrder.orderNumber }}</h1>
    </div>
    <div class="col-sm-6 d-none d-lg-block"><h3>Servisni nalog</h3></div>
    <div class="col-sm-3">
      <h2><OrderBadge :workOrder="workOrder" /></h2>
    </div>
  </div>

  <div class="row">
    <div class="col"><h3>Ostali nalogi na tem objektu</h3></div>
  </div>

  <div class="row">
    <div class="col">
      <WorkOrdersList
        :workOrders="orders"
        @assignTo="assignToAsync"
        @setDatePlannedVisit="handleSetDatePlannedVisitAsync"
      />
    </div>
  </div>

  <div class="row mb-5">
    <div class="col-2 text-start"></div>
    <div class="col-10 text-end">
      <button
        class="btn btn-outline-secondary me-3"
        type="button"
        v-show="workOrder?.id"
        @click="$router.push({ name: 'ServiceOrder', params: { workOrderId: workOrder.id } })"
      >
        Prekliči
      </button>
      <button class="btn btn-success btn-lg me-3" type="button" v-show="workOrder?.canComplete" @click="gotoSigning">
        Podpis stranke
      </button>
    </div>
  </div>
</template>

<script setup>
/* global VueRouter */
import { ref, toRef, toRefs, computed, defineComponent, watch, reactive, inject } from "vue"
import { useAuth } from "../composition-api/useAuth"
import { useWorkOrders } from "../composition-api/useWorkOrders"
import { useWorkOrder } from "../composition-api/useWorkOrder"
import { setError, startLoading, stopLoading, setSuccess } from "../components/Notification"
import { patchWorkOrderAsync } from "../api"
import WorkOrdersList from "../components/WorkOrdersList.vue"

defineOptions({ name: "FacilityServiceOrders" })

const props = defineProps({
  noSign: { type: Boolean, default: false },
})

const route = VueRouter.useRoute()
const router = VueRouter.useRouter()

const { workOrder, changeOwnerAsync } = useWorkOrder("Service")
const { fetchAuthAsync } = useAuth()
const getDefaultFilters = () => {
  return {
    facility: workOrder.value?.facilityID,
    status: "Active,Accepted,InProgress",
  }
}
const { paging, filters, orders, getOrdersAsync, resetFilters } = useWorkOrders("Service", getDefaultFilters)

const assignToAsync = async (req) => {
  if (!req.order || !req.selectedWorker) {
    console.warn("assignToAsync: invalid request", req)
    return
  }
  console.log(req)
  if (await changeOwnerAsync(req.order.id, req.selectedWorker)) {
    await getOrdersAsync()
  }
}

const handleSetDatePlannedVisitAsync = async ({ order, datePlannedVisit }) => {
  if (await patchWorkOrderAsync(fetchAuthAsync, { datePlannedVisit }, "Service", order.id)) {
    await getOrdersAsync()
  }
}

const selectOrder = (order, openInNewWindow = false) => {
  // TODO: duplicate
  const routeData = router.resolve({ name: "ServiceOrder", params: { workOrderId: order.id } })
  if (openInNewWindow) {
    window.open(routeData.href, "_blank")
  } else {
    router.push(routeData)
  }
}

const gotoSigning = () =>
  router.push({ name: "SignOrder", params: { workOrderId: workOrder.value.id, keepMessages: true } })

const unwatch = watch(
  workOrder,
  async (wo) => {
    if (!wo) return
    unwatch()
    startLoading("FacilityServiceOrders")
    try {
      resetFilters()
      await getOrdersAsync()
      if (orders.value.length === 1 && !props.noSign) {
        console.log("Only one order, going to signing", workOrder.value?.id)
        gotoSigning()
      }
    } catch (e) {
      setError(e)
    }
    stopLoading("FacilityServiceOrders")
  },
  { immediate: true },
)
</script>
